export interface SortPref {
  key: string;
  dir: "asc" | "desc";
}

const PREFIX = "cc.table.";

function readJSON<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

function writeJSON(key: string, value: unknown): void {
  try {
    if (value === null || value === undefined) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  } catch {
    // ignore
  }
}

export const tablePrefs = {
  getSort(storageKey: string): SortPref | null {
    return readJSON<SortPref>(`${PREFIX}${storageKey}.sort`);
  },
  setSort(storageKey: string, sort: SortPref | null): void {
    writeJSON(`${PREFIX}${storageKey}.sort`, sort);
  },
  getHidden(storageKey: string): string[] {
    return readJSON<string[]>(`${PREFIX}${storageKey}.hidden`) ?? [];
  },
  setHidden(storageKey: string, hidden: string[]): void {
    writeJSON(`${PREFIX}${storageKey}.hidden`, hidden.length ? hidden : null);
  },
};
